import {
  WorkflowNodeData,
  WorkflowNodeTypes,
  SettingParamTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const objectionNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.OBJECTION,
  data: {
    type: WorkflowNodeTypes.OBJECTION,
    settingsTitle: "Objection Settings",
    description: "This is the objection node",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [],
  },
  position: {x: 0, y: 0},
};
